const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const FALLBACK_EMPTY_LINK_TEXT = 'Empty Link Text';

export const extractSecureNoteTitleFromHtml = (html: string, noteId: string): string => {
  if (!html || !noteId) {
    return '';
  }

  const escapedNoteId = escapeRegExp(noteId);
  const secureNotePattern = new RegExp(
    `<a[^>]*href="[^"']*?/secure-note/${escapedNoteId}[^"']*"[^>]*>([\\s\\S]*?)<\\/a>`,
    'i',
  );
  const match = html.match(secureNotePattern);

  if (!match) {
    return '';
  }

  const rawText = match[1] ?? '';
  const cleanedText = rawText.replace(/<[^>]+>/g, '').trim();

  return cleanedText || FALLBACK_EMPTY_LINK_TEXT;
};
